import {
	Typography, TextField, Button, Dialog, Tooltip,
	DialogActions, DialogContent, DialogTitle, IconButton
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import LensIcon from '@material-ui/icons/Lens';
import SettingsIcon from '@material-ui/icons/Settings';
import React, { useState } from "react";
import { HuePicker } from 'react-color';
import { useActions } from 'kea';

import geofencelogic from 'src/store/geofence';

const useStyles = makeStyles(() => ({
	popover: {
		position: 'absolute',
		zIndex: '99999',
	},
	cover: {
		position: 'fixed',
		top: '0px',
		right: '0px',
		bottom: '0px',
		left: '0px',
	},
	picker: {
		position: 'fixed',
		width: '400px'
	}
}));

const SettingsDialog = (props) => {
	const classes = useStyles();
	const [existingGeofence, setExistingGeofence] = useState(props.geofence);
	const [displayFillColorPicker, setDisplayFillColorPicker] = useState(false);
	const [displayStrokeColorPicker, setDisplayStrokeColorPicker] = useState(false);
	const { update } = useActions(geofencelogic);

	const [geofenceDialog, setGeofenceDialog] = useState(false);

	const handleClickOpen = () => {
		setGeofenceDialog(true);
	}

	const handleClose = () => {
		setGeofenceDialog(false);
		setExistingGeofence(props.geofence);
	}

	const handleCreate = () => {
		update(existingGeofence);
		setGeofenceDialog(false);
	}

	const handleFillcolorPicker = () => {
		setDisplayFillColorPicker(!displayFillColorPicker);
	};

	const handleFillcolorPickerClose = () => {
		setDisplayFillColorPicker(false);
	};

	const handleFillcolorPickerChange = (color) => {
		let updated_geofence = { ...existingGeofence };
		updated_geofence.polygon.properties.fillColor = color.hex;
		setExistingGeofence(updated_geofence);
	};


	const handleStrokecolorPicker = () => {
		setDisplayStrokeColorPicker(!displayStrokeColorPicker);
	};

	const handleStrokecolorPickerClose = () => {
		setDisplayStrokeColorPicker(false);
	};

	const handleStrokecolorPickerChange = (color) => {
		let updated_geofence = { ...existingGeofence };
		updated_geofence.polygon.properties.strokeColor = color.hex;
		setExistingGeofence(updated_geofence);
	};


	return (
		<>
			<Tooltip title='Geofence Settings'>
				<IconButton aria-label="settings" onClick={handleClickOpen}
					size='small'
				>
					<SettingsIcon
					/>
				</IconButton>
			</Tooltip>
			<Dialog
				open={geofenceDialog}
				onClose={handleClose}
				aria-labelledby="form-dialog-title"
				id={'rnd-ignore-drag'}
			>
				<DialogTitle id="form-dialog-title">Change properties of a Geofence.</DialogTitle>
				<DialogContent>
					<TextField
						margin="dense"
						label="Geofence Name"
						type="text"
						fullWidth
						value={existingGeofence.name}
						onChange={(e) => setExistingGeofence({ ...existingGeofence, name: e.target.value })}
						inputProps={{
							maxLength: 24
						}}
					/>
					<Typography>
						Fill Color:
						<IconButton aria-label="settings" onClick={handleFillcolorPicker}>
							<LensIcon style={{ color: existingGeofence.polygon.properties.fillColor }} />
						</IconButton>
					</Typography>

					{
						displayFillColorPicker
							?
							<div className={classes.popover}>
								<div className={classes.cover} onClick={handleFillcolorPickerClose} />
								<div style={{ padding: '5px', backgroundColor: '#ffffff', boxShadow: '0 0 0 1px rgba(0,0,0,.1)', }}>
									<HuePicker width={220} color={existingGeofence.polygon.properties.fillColor} onChange={handleFillcolorPickerChange} />
								</div>
							</div>
							:
							null
					}
					<Typography>
						Border Color:
						<IconButton aria-label="settings" onClick={handleStrokecolorPicker}>
							<LensIcon style={{ color: existingGeofence.polygon.properties.strokeColor }} />
						</IconButton>
					</Typography>

					{
						displayStrokeColorPicker
							?
							<div className={classes.popover}>
								<div className={classes.cover} onClick={handleStrokecolorPickerClose} />
								<div style={{ padding: '5px', backgroundColor: '#ffffff', boxShadow: '0 0 0 1px rgba(0,0,0,.1)', }}>
									<HuePicker width={220} color={existingGeofence.polygon.properties.strokeColor} onChange={handleStrokecolorPickerChange} />
								</div>
							</div>
							:
							null
					}
					{/* <PhotoshopPicker onChangeComplete={ (color, event) => {
			let updated_geofence = [...existingGeofence];
			updated_geofence.polygon.properties.fillColor = color;
			setExistingGeofence(updated_geofence);
		} } />; */}
				</DialogContent>
				<DialogActions>
					<Button onClick={handleClose} color="primary">
						Cancel
					</Button>
					<Button onClick={handleCreate} color="primary">
						Edit
					</Button>
				</DialogActions>
			</Dialog>
		</>
	);
};

export default SettingsDialog;
